/**
 * Drive or Kick wordmark logo. Rendered on a small white pill so the green-outlined
 * letters stay readable on the dark UI. Variants only differ in height.
 */
export default function BrandLogo({ size = "md", className = "", testid = "brand-logo" }) {
    const h = size === "sm" ? "h-7" : size === "lg" ? "h-12" : "h-9";
    return (
        <img
            src="/dok-logo.png"
            alt="Drive or Kick"
            data-testid={testid}
            className={`${h} w-auto object-contain bg-white rounded px-2 py-1 ${className}`}
        />
    );
}
